import styled from 'styled-components';

export const Cell = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`;

export const CellData = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex: 0 0 100px;
  margin-left: auto;
  margin-right: 10px;
`;

